import { useState } from 'react';

const useTurniDragDrop = ({ handleDrop, handleDeleteTurno, handleUpdateFerieStatus }) => {
  const [isDragOverTrash, setIsDragOverTrash] = useState(false);
  const [isDropTypeOpen, setIsDropTypeOpen] = useState(false);
  const [pendingDropData, setPendingDropData] = useState({ name: '', date: '' });

  const onDrop = (e, dateStr) => {
    const droppedName = handleDrop(e, dateStr);
    if (droppedName) {
      setPendingDropData({ name: droppedName, date: dateStr });
      setIsDropTypeOpen(true);
    }
  };

  const handleShiftDragStart = (e, shiftId) => e.dataTransfer.setData('shiftId', String(shiftId));
  const handleLeaveDragStart = (e, leaveId) => e.dataTransfer.setData('leaveId', String(leaveId));

  const handleTrashDrop = async (e) => {
    e.preventDefault();
    setIsDragOverTrash(false);
    const shiftId = e.dataTransfer.getData('shiftId');
    const leaveId = e.dataTransfer.getData('leaveId');
    if (shiftId) {
      try { await handleDeleteTurno(Number(shiftId)); } catch (_e) {}
    } else if (leaveId) {
      try { await handleUpdateFerieStatus(Number(leaveId), 'rifiutata'); } catch (_e) {}
    }
  };

  return {
    isDragOverTrash, setIsDragOverTrash,
    isDropTypeOpen, setIsDropTypeOpen,
    pendingDropData, onDrop,
    handleShiftDragStart, handleLeaveDragStart, handleTrashDrop,
  };
};

export default useTurniDragDrop;
